/**
 * Creates transition for consistency
 * @param timeInSec number of seconds
 */
export const transition = (timeInSec?: number) => {
  return {
    transition: `all ease-in-out ${timeInSec || 0.3}s`,
  };
};
